// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sk-code-editor{min-height:256px;position:relative}.sk-code-editor pre{background:none;border:0}.sk-code-editor textarea{border:1px solid #ccc}", ""]);
// Exports
module.exports = exports;
